import React, { useState, useEffect, forwardRef } from "react";
import { TextField, IconButton, FormControl, InputLabel, NativeSelect,
          Box, Typography, Switch, Button, Tooltip } from "@material-ui/core"; // Ensure you have Material-UI installed
import DeleteIcon from "@material-ui/icons/Delete";
import AddIcon from "@material-ui/icons/Add";
import { makeStyles } from "@material-ui/core/styles";
import useStyles from './styles';
import './CustomProperties.css'
import classnames from "classnames";

const CustomProperties = forwardRef((props, ref) => {
  const { customerProperties, enableCustomProperties, onCustomerPropertiesChanged, onCustomPropertiesEnableChanged } = props;
  // Ensure customerProperties is parsed correctly
  const initialProperties = typeof customerProperties === "string"
    ? JSON.parse(customerProperties || '[]')
    : Array.isArray(customerProperties) ? customerProperties : [];

  const [customProperties, setCustomProperties] = useState(initialProperties);
  const [isCustomPropertiesEnabled, setIsCustomPropertiesEnabled] = useState(enableCustomProperties || false);

  const classes = useStyles();

  // Function to handle input changes
  const handleInputChange = (index, event) => {
    const { name, value } = event.target;
    const properties = [...customProperties];
    const updatedProperty = { ...properties[index], [name]: value.trim() }; // Update only the field that changed
    properties[index] = updatedProperty; // Assign the updated property back to the array
    setCustomProperties(properties);
    // Validate the property before triggering the parent change
    const isPropertyValid = updatedProperty.name.trim() !== '' && updatedProperty.type.trim() !== '';

    if (isPropertyValid) {
      onCustomerPropertiesChanged(JSON.stringify(properties)); // Trigger custom properties change to parent
    }
  };

  // Function to add a new custom property
  const addCustomProperty = () => {
    // Check if customProperties is defined
    if (Array.isArray(customProperties)) {
      const newProperties = [...customProperties, { name: '', type: 'text' }];
      setCustomProperties(newProperties);
      // new entry has no value, don't save to parent yet
      //onCustomerPropertiesChanged(JSON.stringify(newProperties)); // Trigger custom properties change to parent
    } else {
      console.error("customProperties is not an array");
    }
  };

  // Function to delete a custom property
  const deleteCustomProperty = (index) => {
    const properties = customProperties.filter((_, i) => i !== index);
    setCustomProperties(properties);
    onCustomerPropertiesChanged(properties); // Trigger custom properties change to parent
  };

  // Function to handle toggle of enable/disable custom properties
  const handleToggleCustomProperties = () => {
    const newState = !isCustomPropertiesEnabled;
    setIsCustomPropertiesEnabled(newState);
    onCustomPropertiesEnableChanged(newState); // Separate change notification for enabling/disabling custom properties
  };


  return (
    <div className={classes.customPropertiesContainer}>
      <Box display={"flex"} alignItems={"center"}>
          <Typography weight={"medium"}>
              Enable Custom Properties
          </Typography>
          <Switch color={"primary"} checked={isCustomPropertiesEnabled}
                  onClick={handleToggleCustomProperties} />
      </Box>
      {isCustomPropertiesEnabled && (
        <>
          {customProperties.length > 0 ? (
            customProperties.map((property, index) => (
              <div key={index} className={classes.customProperty}>
                <TextField
                  id="name"
                  variant="outlined"
                  name="name"
                  label="Property Name"
                  autoComplete='off'
                  size="small"
                  value={property.name || ''}
                  className={classnames({
                    'property-name': true,
                  })}
                  onChange={(event) => handleInputChange(index, event)}
                  required
                  error={property.name === undefined || property.name.trim() === ''}
                  helperText={property.name === undefined || property.name.trim() === '' ? 'Please provide a name.' : ' '}
                />
                <FormControl variant="outlined" className={classnames({
                      'customPropertiesTypeSelect':  true,
                      'custom-properties-type-select-control': true
                    })}>
                  <InputLabel>Type<sup>*</sup></InputLabel>
                  <div className={classnames({
                                'custom-properties-type-select-control-input': true
                              })}>
                    <NativeSelect
                      value={property.type}
                      name="type"
                      required
                      onChange={(event) => handleInputChange(index, event)}
                    >
                       <option value="text">Text</option>
                       <option value="number">Number</option>
                    </NativeSelect>
                  </div>
                </FormControl>
                <Tooltip title="Delete">
                    <IconButton
                      className={classes.customPropertyButton}
                      onClick={() => deleteCustomProperty(index)}
                    >
                      <DeleteIcon />
                    </IconButton>
                </Tooltip>
              </div>
            ))
          ) : (
            <p>No custom properties available.</p>
          )}
          <Button onClick={addCustomProperty}>
              <Box mr={1} display={'flex'}>
                  <AddIcon />
              </Box>
              ADD
          </Button>
        </>
      )}
    </div>
  );
});

export default CustomProperties;
